export default "__VITE_ASSET__14985493__"